module.exports = "<div *ngFor=\"let breadcrumb of breadcrumbs;let last = last\" style=\"margin:10px\">\r\n  <li class=\"breadcrumb-item\" *ngIf=\"breadcrumb.label.title\" [ngClass]=\"{active: last}\">\r\n    <a *ngIf=\"!last\" [routerLink]=\"breadcrumb.url\">{{breadcrumb.label.title}}/</a>\r\n    <span *ngIf=\"last\" [routerLink]=\"breadcrumb.url\">{{breadcrumb.label.title}}</span>\r\n  </li>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/shared/breadcrumb.component.html
// module id = ../../../../../src/app/shared/breadcrumb.component.html
// module chunks = main